import { Body, cn } from '@growtherapy/sprout-ui';

import { Toast } from '../../toasts/Toast';
import { ModifiedToastAria } from '../../toasts/types';

type MeasureCompletedToastProps = {
  heading: string;
} & ModifiedToastAria;

export function MeasureCompletedToast({
  contentProps,
  titleProps,
  heading,
  ...toastAriaProps
}: MeasureCompletedToastProps) {
  return (
    <Toast
      alignment='top'
      className='max-w-4xl w-full sm:w-full'
      closeButtonSize='sm'
      contentClassName='rebrand:items-start rebrand:md:items-center'
      {...toastAriaProps}
    >
      <div className='flex flex-1 flex-col md:flex-row justify-start gap-3 min-w-0 w-full md:items-start rebrand:md:items-center'>
        <div {...contentProps} className={cn('flex min-w-0 w-full flex-col gap-1 md:w-max', contentProps?.className)}>
          <Body.Default
            as='h3'
            {...titleProps}
            className={cn('!font-semibold !text-text-default fs-exclude', titleProps.className)}
            data-dd-privacy='mask'
          >
            {heading}
          </Body.Default>
        </div>
      </div>
    </Toast>
  );
}
